var exports = {
  "Vq": "ChannelGlyphView.module__glyph___TDlNU1",
  "Kk": "ChannelGlyphView.module__icon___TDlNU1",
  "Sl": "ChannelGlyphView.module__image___TDlNU1",
  "Qq": "ChannelGlyphView.module__text___TDlNU1",
};

module.exports = exports;
